import React from 'react';
import PropTypes from 'prop-types';
import { APP, SMART_SENSOR_DCU } from '../constants';

const GatewayEventTableHeader = ({ translate, eventSource }) => {

    const isAppTab = eventSource === APP;
    const isGatewayTab = eventSource === SMART_SENSOR_DCU;

    if (isAppTab) {
        return (
            <div className='gateway-event-header gateway-event-header--app'>
                <div className='gateway-event-header-cell event-name-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementEventFileName')}
                </div>
                <div className='gateway-event-header-cell organization-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementOrganization')}
                </div>
                <div className='gateway-event-header-cell timestamp-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementLocalTime')}
                </div>
                <div className='gateway-event-header-cell utc-timestamp-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementUTCTime')}
                </div>
                <div className='gateway-event-header-cell user-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementUser')}
                </div>
                <div className='gateway-event-header-cell app-version-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementAPPVersion')}
                </div>
                <div className='gateway-event-header-cell os-version-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementOSVersion')}
                </div>
                <div className='gateway-event-header-cell attachment-header' />
            </div>
        );
    }

    if (isGatewayTab) {
        return (
            <div className='gateway-event-header gateway-event-header--gateway'>
                <div className='gateway-event-header-cell event-name-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementEventFileName')}
                </div>
                <div className='gateway-event-header-cell type-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementType')}
                </div>
                <div className='gateway-event-header-cell serial-number-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementSerialNumber')}
                </div>
                <div className='gateway-event-header-cell level-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementLevel')}
                </div>
                <div className='gateway-event-header-cell organization-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementOrganization')}
                </div>
                <div className='gateway-event-header-cell timestamp-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementLocalTime')}
                </div>
                <div className='gateway-event-header-cell utc-timestamp-header'>
                    {translate('ABB.Powertrain.Frontend.gatewayManagementUTCTime')}
                </div>
                <div className='gateway-event-header-cell attachment-header' />
            </div>
        );
    }

    // Drive DCU and SmartSensor: Name | DCU serial number | Local time | UTC | Download
    return (
        <div className='gateway-event-header gateway-event-header--simple'>
            <div className='gateway-event-header-cell event-name-header'>
                {translate('ABB.Powertrain.Frontend.gatewayManagementEventName')}
            </div>
            <div className='gateway-event-header-cell serial-number-header'>
                {translate('ABB.Powertrain.Frontend.gatewayManagementSerialNumber')}
            </div>
            <div className='gateway-event-header-cell timestamp-header'>
                {translate('ABB.Powertrain.Frontend.gatewayManagementLocalTime')}
            </div>
            <div className='gateway-event-header-cell utc-timestamp-header'>
                {translate('ABB.Powertrain.Frontend.gatewayManagementUTCTime')}
            </div>
            <div className='gateway-event-header-cell attachment-header' />
        </div>
    );
};

GatewayEventTableHeader.propTypes = {
    translate: PropTypes.func.isRequired,
    eventSource: PropTypes.string
};

export default GatewayEventTableHeader;
